import styled from '@emotion/styled'

// Textarea is the multi-line counterpart to Input, sharing its token styling.
export const Textarea = styled.textarea`
  background: var(--c-bg-elev);
  color: var(--c-fg);
  border: 1px solid var(--c-border);
  border-radius: var(--r-md);
  padding: 10px 12px;
  font-family: var(--font-sans);
  font-size: 14px;
  width: 100%;
  min-height: 96px;
  resize: vertical;
  line-height: 1.55;
  transition: border-color var(--d-fast) var(--ease-standard);

  &::placeholder {
    color: var(--c-fg-subtle);
  }
  &:focus {
    outline: none;
    border-color: var(--c-accent);
    box-shadow: 0 0 0 3px var(--c-accent-soft);
  }
`
